import { render, staticRenderFns } from "./CompanyUpdateForm.vue?vue&type=template&id=b57395e2&scoped=true&"
import script from "./CompanyUpdateForm.vue?vue&type=script&lang=js&"
export * from "./CompanyUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57395e2",
  null
  
)

export default component.exports